import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { useChatStore } from '@/stores/useChatStore';
import type { ModelLabel } from '@/types/session';
import MessageBubble from './MessageBubble';

interface ChatPanelProps {
  modelLabel: ModelLabel;
}

/**
 * 单栏消息列表，自动滚动到底部。
 */
const ChatPanel: React.FC<ChatPanelProps> = ({ modelLabel }) => {
  const messages = useChatStore((s) =>
    modelLabel === 'left' ? s.leftMessages : s.rightMessages
  );
  const scrollRef = useRef<HTMLDivElement>(null);

  // 自动滚动到底部
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages]);

  const isEmpty = messages.length === 0;
  let runningTurn = 0;
  const messagesWithTurns = messages.map((msg) => {
    if (msg.role === 'user') {
      runningTurn += 1;
    }
    return { msg, turnNumber: runningTurn || 1 };
  });

  return (
    <Box
      ref={scrollRef}
      sx={{
        height: '100%',
        overflowY: 'auto',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}
    >
      {isEmpty ? (
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            等待对话开始...
          </Typography>
        </Box>
      ) : (
        messagesWithTurns.map(({ msg, turnNumber }) => (
          <MessageBubble key={msg.message_id} message={msg} turnNumber={turnNumber} />
        ))
      )}
    </Box>
  );
};

export default ChatPanel;
